import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import api from '../api/axios';

function WebinarPaymentDetail() {
  const { id, nomorhp } = useParams();
  const [payment, setPayment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sequence, setSequence] = useState(null);

  useEffect(() => {
    const fetchPayment = async () => {
      
      try {

        const response = await api.get(`/api/webinar-payment-sequence/${id}`);
        const data = response.data;

        if (data.payment && String(data.payment.number) === String(nomorhp)) {
          setPayment(data.payment);
          setSequence(data.sequence);
        } else {
          setPayment(null);
        }

      } 
      catch (err) {
        setPayment(null);
        console.error('Error fetching webinar payment details:', err);
      } 
      finally {
        setLoading(false);
      }

    };

    fetchPayment();
  }, [id, nomorhp]);

  if (loading) {
    return <div className="container mt-4">Loading data details...</div>;
  }

  if (error) {
    return <div className="container mt-4" style={{ color: 'red' }}>{error}</div>;
  }

  if (!payment) {
    return <div className="container mt-4">Data peserta webinar tidak ditemukan.</div>;
  }

  return (
    <div className="container mt-4">
      <h2 className="text-center">Detail Peserta Webinar</h2>
      {/* buatkan notice bahwa link ini bertahan 1 minggu,silahkan bisa di download sertif,handout,dll */}
      <p className='text-center text-danger'>Link ini bertahan 1 minggu,silahkan bisa di download sertif,handout,dll</p>
      <p><strong>ID Peserta:</strong> {payment.id}</p>
      <p><strong>Nama Peserta:</strong> {payment.name}</p>
      <p><strong>No HP:</strong> {payment.number}</p>
      <p><strong>Status:</strong> {payment.status}</p>
      <p><strong>Nama Webinar:</strong> {payment.webinar ? payment.webinar.title : 'N/A'}</p>
      <p><strong>Record Webinar:</strong> <a href={payment.webinar ? payment.webinar.video : 'N/A'} target="_blank">{payment.webinar ? payment.webinar.video : 'N/A'}</a> </p>
      <p><strong>Handout Webinar:</strong> <a href={payment.webinar ? payment.webinar.benefit : 'N/A'} target="_blank">{payment.webinar ? payment.webinar.benefit : 'N/A'}</a> </p>
      <Link to={`/sertifikat/${payment.webinar.id}/${sequence}/${payment.name}/${payment.number}`} className="btn btn-primary mt-3">Download Sertifikat</Link>
    </div>
  );
}

export default WebinarPaymentDetail;